"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Represents a single message type that might be sent over a channel. Before a channel can be used
 * to send a particular message, the MessageDefinition for that type must be registered with the channel.
 *
 * These are meant to be created once, then imported into both client and server code, to guarantee that
 * both the client and the server are expecting to send/receive the exact same kind of message.
 *
 * Within the channel, the ID of the message must be unique. Generally, this means that each module has
 * its own "namespace" of message IDs with which to create MessageDefinitions.
 */
class MessageDefinition {
    /**
     * Create a new MessageDefinition
     *
     * @param id The ID of the message, which must be unique within the channel that it's being used.
     * @param type The structure of the message payload, which will be used during deserialization and validation.
     */
    constructor(id, type) {
        this.id = id;
        this.type = type;
    }
}
exports.default = MessageDefinition;
//# sourceMappingURL=MessageDefinition.js.map